import React from "react";

export default function PageContainer({ children }: { children: React.ReactNode }) {
  return (
      <div className="w-full max-w-full mx-auto px-3 sm:px-4 lg:px-6 py-6">
      {children}
    </div>
  );
}
